export const cabecalhos = [
  { text: 'Grupo', value: 'grupo' },
  { text: 'Cód. interno', value: 'idproduto' },
  { text: 'Cód. fornecedor', value: 'cod_produto' },
  { text: 'Descrição do produto', value: 'descricao_produto' },
  { text: 'UND', value: 'unidade_compra' },
  { text: 'Estoque segurança', value: 'estoque_seguranca' },
  { text: 'Ponto pedido', value: 'ponto_pedido' },
  { text: 'Estoque máximo', value: 'estoque_maximo' },
  { text: 'Estético', value: 'estoque_minimo' },
  { text: 'Dias gatilho', value: 'dias_gatilho' },
  { text: 'Projeção de vendas', value: 'consumo_medio_mensal_auxiliar' },
  { text: 'Estoque atual', value: 'estoque' },
  { text: 'Cobertura est. futura', value: 'cobertura_estoque_futura' },
  { text: 'Disponivel em outras filiais', value: 'sugestao_transferencia' },
  { text: 'Preço Custo', value: 'preco_custo' },
  { text: 'Sugestão', value: 'sugestao' },
  { text: 'Total', value: 'total' },
];
